import React from 'react'
import {config} from '../config'
const txdomain = config()['tourneyx-url']


const LoginRegister = ({ tournamentDetails,user_information} )=> {
 

  var showLoginButton = false;
  //console.log('user_information passed in LoginRegister::: ', user_information);

 
  //console.log('Converted cutoff date value :::',  new Date(cuttoff_date));
  
  // Change added on 03-11-2021
  
  // Chaitraly 04/Jun/2024 :: TP-367 Jira card :: Added status = 1 condition
  showLoginButton = ( tournamentDetails.status == 0 && tournamentDetails.cuttoff_date != null &&  new Date() > new Date(tournamentDetails.cuttoff_date.replace(/-/g, "/")) ) ? false: true;

  console.log('Current date value :::',  new Date());
  console.log('Tournament end date value :::',  new Date(tournamentDetails.end_date));

  // New condition added to check if user is not logged in on site, show the login to register button option.
  if( ( new Date() < new Date(tournamentDetails.end_date.replace(/-/g, "/")) )) {

    //console.log('Tournament end date is greater than current date, show login button condition::: ')
    
    // Chaitraly 04/Jun/2024 :: TP-367 Jira card :: Added status = 1 condition
    if( user_information && user_information.role == null && tournamentDetails.status == 1){

      console.log('user information is present but role is NULL, show login button in loginRegister.js::')
      console.log('Tournament end date value AFTER:::',  new Date(tournamentDetails.end_date));


      showLoginButton = true;
    }else{
      showLoginButton = false;
    }
    
  }else{
    showLoginButton = false;
  }

  /*
  if( user_information && user_information.role == null){
    console.log('User is not logged in, show login button condtion::');
    showLoginButton = true;
  }else{
    showLoginButton = false;
  }
  */

  //console.log('Is user already registered for the tournament check in loginRegister.js :: ',tournamentDetails.anglers.indexOf(user_information && user_information.user_id) > -1);

  if( (tournamentDetails.anglers && tournamentDetails.anglers.length > 0 ) &&  ( (tournamentDetails.anglers.indexOf( user_information && user_information.user_id) > -1) == true )  ) {
    showLoginButton = false;
  }
  
  console.log('showLoginButton value :::', showLoginButton);

  if(tournamentDetails && tournamentDetails.redirect_to_old_tourney_leaderboard === '1'){
    return (
      <>
        <br></br>
        { showLoginButton 
          ?
          <a href={`${txdomain}/app/login/?redir=${txdomain}/app/tourney-leaderboard/${tournamentDetails.slug}`} className='right-btn'> Login to Register </a> 
          :null
        }
      </>
    )
  }else{
    return (
      <>
        <br></br>
        
        {
          showLoginButton 
          ? 
          <a href={`${txdomain}/app/login/?redir=${txdomain}/leaderboard/standings/${tournamentDetails.slug}`} className='right-btn'> Login to Register </a>
          : null
        }

      
      
      </>
    )
  }


} 

export default LoginRegister